import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  patientNarrativeName: "",
};

const patientNarrativeSlice = createSlice({
  name: "patientNarrative",
  initialState,
  reducers: {
    setPatientNarrativeName: (state, action) => {
      state.patientNarrativeName = action.payload ?? "";
    },
    clearPatientNarrativeName: state => {
      state.patientNarrativeName = "";
    },
  },
});

export const { setPatientNarrativeName, clearPatientNarrativeName } =
  patientNarrativeSlice.actions;
export default patientNarrativeSlice.reducer;
